<template>
  <div
    class="w-full bg-zt-white rounded-zt-md p-6"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center">
      <div class="flex flex-col items-center w-full">
        <graphic-base width="100" height="100" view-box="0 0 126 126">
          <alert-circle :class="keyCloakCode ? 'error-color' : 'warning-color'"/>
        </graphic-base>
        <div v-if="keyCloakCode"
          class="text-center mt-10 text-zt-primary-200"
          :style="[boxLogin.styles.form.textColor]"
        >
          <h1 class="text-zt-lg mb-4 font-bold">
            {{ $t('message.loginComponent.keyCloak.error.title') }}
          </h1>
          <div
            class="text-zt-dark-400"
            :style="[boxLogin.styles.form.textColor]"
          >
            <p class="mb-4">
            {{ $t('message.loginComponent.keyCloak.error.body1') }}
            </p>
            <p class="text-center">{{ $t('message.loginComponent.keyCloak.error.body2') }}</p>
            <span class="italic">{{ $t('message.loginComponent.keyCloak.error.footer', { errorCode: keyCloakCode }) }}</span>
          </div>
        </div>
        <div v-else
          class="text-center mt-10 text-zt-primary-200"
          :style="[boxLogin.styles.form.textColor]"
        >
          <h1 class="text-zt-lg mb-4 font-bold">
            {{ $t('message.loginComponent.keyCloak.notLinked.title') }}
          </h1>
          <div
            class="text-zt-dark-400 text-justify"
            :style="[boxLogin.styles.form.textColor]"
          >
            <p class="mb-4">
              {{ $t('message.loginComponent.keyCloak.notLinked.body') }}
            </p>
            
          </div>
        </div>
      </div>
      <div class="mt-4 w-full">
        <div class="mb-4">
          <zt-button
            class="w-full opacity-100"
            :style="[boxLogin.styles.form.buttons.bgColor]"
            @click="gotoLogin"
            data-vs-button="auth-login-block-btn-gotologin"
          >
            {{ $t('message.modalTimer.buttons.continue') }}
          </zt-button>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import AlertCircle from '@/components/commons/Illustrations/graphicSVG/AlertCircleSVG.vue'
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import { mapGetters } from 'vuex'
import Auth from '@/apiClient/Auth'

export default {
  name: 'ztAuthLoginUserBlock',
  components: { GraphicBase, AlertCircle },
  inject: ['storeUser'],
  mixins: [loginCustomParams],
  data() {
    return {
      objectLoginParams: {}
    }
  },
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams'
    }),
    keyCloakCode() {
      return this.$route.params.code || null
    },
    btnText() {
      return this.continue ? this.$t('message.modalTimer.buttons.continue') : this.$t('message.modalTimer.buttons.close')
    },
  },
  methods: {
    gotoLogin() {
      this.$store.dispatch('clearState')
      this.$router.push({ name: 'login' })
    }
  },
  created() {
    this.auth = new Auth()
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
  }
}
</script>

<style scoped lang="scss">
.format-img {
  height: 100%;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}

::v-deep .zt-button {
  height: 3.25rem;
}

::v-deep .error-color {
  color: #dc2626; // red-600
}

::v-deep .warning-color {
  color: #d97706; // orange-600
}
</style>
